import { Controller } from '@hotwired/stimulus'

// Swaps the preview card's image for a freshly picked file before saving.
export default class extends Controller {
  static targets = ['card']

  changed(event) {
    const file = event.target.files[0]
    if (!file || !this.hasCardTarget) return
    const image = this.cardTarget.querySelector('img')
    if (image) image.src = URL.createObjectURL(file)
  }
}
